// ---------------------------------------------------------------------------
// The app's router (R12c)
//
// One instance for the app, over its route table. Pages import it from here,
// not from sdr-router.ts, which imports every page: that cycle is gone.
// client/startup.ts starts it (after the saved theme is applied) and wires
// page-change.ts to it.
// ---------------------------------------------------------------------------

import { createRouter } from './router.js';
import { ROUTES } from './routes.js';

export const sdrRouter = createRouter(ROUTES);
